import { useState } from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import { Viewer } from "@/components/viewer/Viewer";

const FileCheck = ({ f, i }) => {
  const ok = f.verified;
  const st = f.statement_totals;
  const tone = ok === true ? "bg-emerald-50 text-emerald-800" : ok === false ? "bg-amber-50 text-amber-800" : "bg-slate-50 text-slate-600";
  const text = ok === true
    ? "Totali coincidenti con l'estratto conto"
    : ok === false
      ? `Totali del documento: addebiti ${st.addebiti || "-"} · accrediti ${st.accrediti || "-"}. Controlla il file.`
      : "Totali del documento non trovati";
  return (
    <li data-testid={`file-check-${i}`} className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 rounded-lg px-3 py-2 text-xs ${tone}`}>
      <span className="font-medium truncate">{f.name} · {f.count} movimenti</span>
      <span data-testid={`verification-status-badge-${i}`} className="inline-flex items-center gap-1.5">
        {ok === true ? <CheckCircle2 className="w-4 h-4 shrink-0" /> : <AlertTriangle className="w-4 h-4 shrink-0" />}
        {text}
      </span>
    </li>
  );
};

export const ResultCard = ({ job, baseUrl }) => {
  const s = job.summary;
  const [showAll, setShowAll] = useState(false);
  return (
    <section data-testid="result-summary-card" className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-8 fade-up">
      <h2 className="font-display text-xl sm:text-2xl font-bold text-slate-900">{job.filename}</h2>
      <p className="text-sm text-slate-500 mt-1">{s.files.length} file · {s.pages} pagine lette · {s.count} movimenti ordinati per data · usa i filtri sulle colonne e poi scarica</p>
      <ul className="mt-5 space-y-2">
        {(showAll ? s.files : s.files.slice(0, 4)).map((f, i) => <FileCheck key={i} f={f} i={i} />)}
      </ul>
      {s.files.length > 4 && (
        <button type="button" data-testid="toggle-file-list" onClick={() => setShowAll(!showAll)}
          className="mt-2 text-xs font-semibold text-emerald-700 underline underline-offset-4">
          {showAll ? "Mostra meno" : `Mostra tutti i ${s.files.length} file (${s.files.filter((f) => f.verified === true).length} con totali coincidenti)`}
        </button>
      )}
      <Viewer baseUrl={baseUrl} filename={job.filename} />
    </section>
  );
};
